import React from 'react';
import './Header.css'; // We'll use this for styling
import bew from "../bew.svg";

const Header = () => {
  return (
    <header className="header">
      <img src={bew} alt="bew logo" />
    </header>
  );
};

export default Header;